import React, { useState, useRef, useEffect } from "react";
import InstitueAbout from "../InstitueAbout/InstitueAbout";
import VisionIcon from "../../../assets/images/visionBlueIcon.svg";
import MissionIcon from "../../../assets/images/missionBlueIcon.svg";
import { getCountryMap } from "../../../utils/countryCache";
import { institiuteBtmData } from "../../../utils/dummyData";
import ProfileSummary from "./ProfileSummary";
import styles from "./FullProfile.module.css";
import EventHosted from "./EventHosted";
import MembershipRecognition from "./MembershipRecognition";
import PublicationsOutputs from "./PublicationsOutputs";
import ImpactMetrics from "./ImpactMetrics";
import PeopleLiaisons from "./PeopleLiaisons";
import Gallery from "./Gallery";

export default function FullProfile(props) {
  const { profile, isOpen } = props;
  const [activeTab, setActiveTab] = useState("overview");
  const [isMobile, setIsMobile] = useState(false);
  const [countryName, setCountryName] = useState(profile.country);

  useEffect(() => {
    let mounted = true;

    getCountryMap().then((map) => {
      if (mounted && map[profile.country]) {
        setCountryName(map[profile.country]);
      }
    });

    return () => {
      mounted = false;
    };
  }, [profile.country]);

  const tabs = [
    { key: "overview", label: "Overview" },
    { key: "membership", label: "Membership & Recognition" },
    { key: "eventsHosted", label: "Events Hosted" },
    { key: "publicationsOutputs", label: "Publications & Outputs" },
    { key: "impactMetrics", label: "Impact & metrics" },
    { key: "people", label: "People & Liaisons" },
    { key: "gallery", label: "Gallery" },
  ];

  const swiperRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        if (swiperRef.current?.swiper) {
          swiperRef.current.swiper.update();
        }
      }, 100);
    }
  }, [isOpen]);

  // Detect mobile screen
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderContent = (tabKey) => {
    switch (tabKey) {
      case "overview":
        return (
          <section>
            <ProfileSummary data={profile} />
          </section>
        );
      case "membership":
        return (
          <section>
            <MembershipRecognition data={profile} />
          </section>
        );
      case "eventsHosted":
        return (
          <section>
            <EventHosted data={profile} />
          </section>
        );
      case "publicationsOutputs":
        return (
          <section>
            <PublicationsOutputs data={profile} />
          </section>
        );
      case "impactMetrics":
        return (
          <section>
            <ImpactMetrics data={profile} />
          </section>
        );
      case "people":
        return (
          <section>
            <PeopleLiaisons data={profile} />
          </section>
        );
      case "gallery":
        return (
          <section>
            <Gallery data={profile} />
          </section>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className={styles.tabOuter}>
        <div className={styles.container}>
          <div className={styles.tabNav}>
            {!isMobile &&
              tabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`${styles.tabBtn} ${
                    activeTab === tab.key ? styles.active : ""
                  }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  <span>{tab.label}</span>
                </button>
              ))}
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.mainContainer}>
          <div className={styles.leftSection}>
            {!isMobile && (
              <div className={styles.tabContent}>
                {renderContent(activeTab)}
              </div>
            )}
            {/* Tabs / Accordion */}
            {isMobile && (
              <div className={styles.accordion}>
                {tabs.map((tab) => (
                  <div key={tab.key} className={styles.accordionItem}>
                    <button
                      className={`${styles.accordionBtn} ${
                        activeTab === tab.key ? styles.active : ""
                      }`}
                      onClick={() =>
                        setActiveTab(activeTab === tab.key ? "" : tab.key)
                      }
                    >
                      {tab.label}
                    </button>
                    {activeTab === tab.key && (
                      <div className={styles.accordionContent}>
                        {renderContent(tab.key)}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className={styles.rightSection}>
            <InstitueAbout
              profile={profile}
              countryName={countryName}
              memberSince={profile.memberSince}
            />
          </div>
        </div>
        <section className={styles.visionMission}>
          <h3>
            Vision <span>& Mission</span>
          </h3>
          <div className={styles.cards}>
            <div className={styles.card}>
              <div className={styles.image}>
                <img src={VisionIcon} alt="Our Vision" /> <h4>Vision</h4>
              </div>

              <p>
                To be the premier platform for advancing research excellence,
                fostering innovation, and creating meaningful connections
                between researchers, mentors, and industry leaders worldwide.
              </p>
            </div>
            <div className={styles.card}>
              <div className={styles.image}>
                <img src={MissionIcon} alt="Our Mission" /> <h4>Mission</h4>
              </div>

              <p>
                To empower researchers through strategic mentorship,
                collaborative initiatives, and innovative programs that bridge
                the gap between academic excellence and real-world impact.
              </p>
            </div>
          </div>
        </section>
        <section className={`${styles.imparcPartners}  ${styles.mediakit}`}>
          <div className={styles.cards}>
            {institiuteBtmData.map((item) => (
              <div key={item.id} className={styles.card}>
                <div className={`${styles.image}`}>
                  <img src={item.img} alt={item.title} />
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
